import { Routes } from '@angular/router';
import { MistGuestWifiComponent } from '@app/features/mists/modules/guest-wifi/components/guest-wifi/guest-wifi.component';
import { Authority } from '@app/shared/utils/enums';

export const mistGuestWifiRoutes: Routes = [
    {
        path: 'mist-guest-wifi',
        children: [
            {
                path: '',
                component: MistGuestWifiComponent,
                data: {
                    authorities: [Authority.UPDATE]
                }
            }
        ]
    }
]